import React from 'react'
import { DoughnutChart } from '../../../../../../Charts/Dougnut/doughnut'

import GridElementContainer from '../../../GridElementContainer'
import TopCategory from './TopCategory'

import { copyObject } from '../../../../../../../helpers'

import { topCategoryColors } from '../../../../../../../constants'

const TopCategories = ({
  title = 'Top Categories',
  topCategories: allTopCategories = [],
  firstCircleSize,
  secondCircleSize,
  thirdCircleSize,
  className = '',
  containerClassName = '',
  containerTitleClassName = '',
  doughnutWrapperClassName = '',
  itemClassName = '',
  itemContainerClassName = '',
  itemTitleClassName = '',
  itemTitleWrapperClassName = '',
  emptyMessage = 'Your Top Category Will Show Here After You Take Few Classes',
}) => {
  const topCategories = copyObject(allTopCategories)
    .sort((a, b) => {
      return a.total_bookings - b.total_bookings
    })
    .slice(allTopCategories.length - 3, allTopCategories.length)
    .reverse()

  const tutorTopCategoriesContent = topCategories.map((category, index) => {
    return (
      <TopCategory
        key={category.category}
        category={category}
        color={topCategoryColors[index]}
        className={itemClassName}
        containerClassName={itemContainerClassName}
        titleClassName={itemTitleClassName}
        titleWrapperClassName={itemTitleWrapperClassName}
      />
    )
  })

  return (
    <GridElementContainer
      className={containerClassName}
      titleClassName={containerTitleClassName}
      title={title}
    >
      <div className={`${className} w-full h-full`}>
        {topCategories.length ? (
          <div className="flex justify-between">
            <div
              className={`borderViewLightPink w-[50%] flex justify-center items-center rounded h-[14rem] mr-[10px] ${doughnutWrapperClassName}`}
            >
              <DoughnutChart
                topCategories={topCategories}
                firstCircleSize={firstCircleSize}
                secondCircleSize={secondCircleSize}
                thirdCircleSize={thirdCircleSize}
              />
            </div>

            <div className="flex-1 grid gap-2 top_categories">{tutorTopCategoriesContent}</div>
          </div>
        ) : (
          <div className="w-full h-full flex items-center justify-center flex-col border-[#FFCA84] border-[1px] rounded-[6px] p-[10px]">
            <img
              src="/assets/icon/empty-categories.svg"
              alt="Empty Categories"
              className="w-[117px] h-[106px]"
            />

            <p className="text-base leading-[29px] text-primary-100 font-bold mt-[19px] text-center">
              {emptyMessage}
            </p>
          </div>
        )}
      </div>
    </GridElementContainer>
  )
}

export default TopCategories
